var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "videoMessage",
      on: {
        mouseenter: function ($event) {
          _vm.videoHovered = true
        },
        mouseleave: function ($event) {
          _vm.videoHovered = false
        },
      },
    },
    [
      _c("custom-video-player", {
        ref: "videoPlayer",
        staticClass: "video-player-box",
        attrs: {
          src: _vm.videoSrc(),
          "max-width": 400,
          "max-height": 300,
          "playback-rates": [0.7, 1.0, 1.5, 2.0],
          muted: false,
          timestamp: _vm.displayTimestamp,
          "timestamp-tooltip": _vm.timestampTooltip,
        },
      }),
      _vm._v(" "),
      _vm.actorInfo
        ? _c(
            "div",
            { staticClass: "actor-info-bar" },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("info_outline"),
              ]),
              _vm._v(" "),
              !_vm.actorInfo.link
                ? _c("span", [_vm._v(_vm._s(_vm.actorInfo.text))])
                : _c(
                    "router-link",
                    {
                      staticClass: "actor-link",
                      attrs: { to: _vm.actorInfo.link },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.actorInfo.text) +
                          "\n            "
                      ),
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "10px" },
                        },
                        [_vm._v("open_in_new")]
                      ),
                    ]
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.videoHovered && _vm.message
        ? _c(
            "div",
            {
              staticClass: "video-gallery-btn",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.$emit("open-gallery", _vm.message)
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("collections"),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }